export default "../css/d361eeabc34e78eddc47582f73a185a9.ttf";